import { render } from "./SoundWordMatching.vue?vue&type=template&id=249ea266"
import script from "./SoundWordMatching.vue?vue&type=script&lang=js"
export * from "./SoundWordMatching.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__